import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Tabber from 'components/Tabber';
import RegionEditMain from 'components/RegionEditMain';
import RegionEditCities from 'components/RegionEditCities';

import { RegionEditTabs_region$key } from '__generated__/RegionEditTabs_region.graphql';

type Props = {
  region: RegionEditTabs_region$key;
};

const RegionEditTabs: FC<Props> = props => {
  const region = useFragment(
    graphql`
      fragment RegionEditTabs_region on Region {
        ...RegionEditMain_region
        ...RegionEditCities_region
      }
    `,
    props.region
  );

  return (
    <Tabber
      tabs={[
        {
          title: 'Bendra informacija',
          component: <RegionEditMain region={region} />,
          hash: 'main',
        },
        {
          title: 'Miestai',
          component: <RegionEditCities region={region} />,
          hash: 'cities',
        },
      ]}
    />
  );
};

export default RegionEditTabs;
